import { IAMetricxTags } from '../../../../constants/enums/ia-metricx-tags';
export default class SmartcareMetricxTags {
    private static executionTag: string;
    private static groupingTag: string;

    public static generateExecutionTag(): void {
        this.executionTag = crypto.randomUUID();
    }
    
    public static getExecutionTag(): string {
        return this.executionTag;
    }

    public static setGroupingTag(featureName: string): void {
        this.groupingTag = featureName;
    }

    public static getGroupingTag(): string {
        return this.groupingTag;
    }

    public static mountTags(otherTags: {[key:string]:string} = {}): {[key:string]:string} {
        return {
            [IAMetricxTags.EXECUTION_TAG]: this.getExecutionTag(),
            [IAMetricxTags.GROUPING_TAG]: this.getGroupingTag(),
            [IAMetricxTags.SOURCE_TAG]: IAMetricxTags.MOBILE_SOURCE,
            ...otherTags
        }
    }
    
    public static createAllTags(groupingTag: string): void {
        SmartcareMetricxTags.generateExecutionTag();
        SmartcareMetricxTags.setGroupingTag(groupingTag);
    }
}
